/**************************************************
 * Nombre:       Tarjeta_Historias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Historias = ({item}) => {
    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 10, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>

                <video width={'100%'} height={!masSM ? 460 : 630}
                       style={{
                           objectFit: 'cover', borderRadius: 20,
                           zIndex: 1
                       }}
                       id="background-video" controls loop muted //poster={fondo_img}
                >
                    <source src={item.video} type="video/mp4"/>
                </video>
            </Grid>

            <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', pl: sCell ? 0 : 6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sTab ? 0 : 6}}>
                        <Typography sx={{color: '#262626', fontSize: !masSM ? 16 : 20, fontWeight: 400}}>
                            {item.titulo}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                        <Typography
                            sx={{color: '#262626', fontSize: !masSM ? 32 : 36, fontWeight: 700, lineHeight: 1.1}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#545454', fontSize: !masSM ? 16 : 18, fontWeight: 400, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 6
                        }}>
                            {item.parrafoUno}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#545454', fontSize: sCell ? 16 : 18, fontWeight: 400, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 6
                        }}>
                            {item.parrafoDos}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Historias